const ROOT = 'Root'
const ORG_ADMIN = 'OrgAdmin'
const USER = 'User'
const CONTENT_MNGR = 'ContentManager'
const CONTENT_MNGR_API = 'Content Manager'

const SEC_ENG = 'Security Engineer'
const SEC_ANALYST = 'Security Analyst'
const VIEWER = 'Viewer'
const NO_ACCESS = 'No Access'

const TENANT_ADMIN = 'TenantAdmin'
const ADMINISTRATOR = 'Administrator'
const CUSTOM = 'Custom'
const INIT = 'Init'

// All User Types
const userTypes = [ROOT, ORG_ADMIN, USER, CONTENT_MNGR]

// Different User Roles
const userRoles = [SEC_ENG, SEC_ANALYST, VIEWER, NO_ACCESS]

const blankAccess = ['']
const rootInitAccess = [`${ROOT} - ${INIT}`] // Role to create a first tenant

// Mapping all Users with all roles
const rootBasic = userRoles.map(d => `${ROOT} - ` + d)
const userBasic = userRoles.map(d => `${USER} - ` + d)
const orgAdminBasic = userRoles.map(d => `${ORG_ADMIN} - ` + d)
const contentMngrBasic = userRoles.map(d => `${CONTENT_MNGR} - ` + d)

// Mapping all Users with Security Analyst role
const rootSecAnalysts = [`${ROOT} - ${SEC_ANALYST}`]
const userSecAnalysts = [`${USER} - ${SEC_ANALYST}`]
const orgAdminSecAnalysts = [`${ORG_ADMIN} - ${SEC_ANALYST}`]
const contentMngrSecAnalysts = [`${CONTENT_MNGR} - ${SEC_ANALYST}`]

// Mapping all Users with Security Engineer role
const rootSecEng = [`${ROOT} - ${SEC_ENG}`]
const userSecEng = [`${USER} - ${SEC_ENG}`]
const orgAdminSecEng = [`${ORG_ADMIN} - ${SEC_ENG}`]
const contentMngrSecEng = [`${CONTENT_MNGR} - ${SEC_ENG}`]

// Creating all TenantAdmin Users
const rootTenantAdmin = [`${ROOT} - ${TENANT_ADMIN}`, `${ROOT} - ${TENANT_ADMIN} - ${NO_ACCESS}`]
const userTenantAdmin = [`${USER} - ${TENANT_ADMIN}`, `${USER} - ${TENANT_ADMIN} - ${NO_ACCESS}`]
const orgAdminTenantAdmin = [
  `${ORG_ADMIN} - ${TENANT_ADMIN}`,
  `${ORG_ADMIN} - ${TENANT_ADMIN} - ${NO_ACCESS}`,
]
const contentMngrTenantAdmin = [
  `${CONTENT_MNGR} - ${TENANT_ADMIN}`,
  `${CONTENT_MNGR} - ${TENANT_ADMIN} - ${NO_ACCESS}`,
]

// Mapping all Users with Viewer role
const rootViewer = [`${ROOT} - ${VIEWER}`]
const userViewer = [`${USER} - ${VIEWER}`]
const orgAdminViewer = [`${ORG_ADMIN} - ${VIEWER}`]
const contentMngrViewer = [`${CONTENT_MNGR} - ${VIEWER}`]

// Mapping all TenantAdmin Users with Security Engineer role
const rootTenantAdminSecEng = [`${ROOT} - ${TENANT_ADMIN} - ${SEC_ENG}`]
const userTenantAdminSecEng = [`${USER} - ${TENANT_ADMIN} - ${SEC_ENG}`]
const orgAdminTenantAdminSecEng = [`${ORG_ADMIN} - ${TENANT_ADMIN} - ${SEC_ENG}`]
const contentMngrTenantAdminSecEng = [`${CONTENT_MNGR} - ${TENANT_ADMIN} - ${SEC_ENG}`]

// Mapping all TenantAdmin Users with Security Analyst role
const rootTenantAdminSecAnalyst = [`${ROOT} - ${TENANT_ADMIN} - ${SEC_ANALYST}`]
const userTenantAdminSecAnalyst = [`${USER} - ${TENANT_ADMIN} - ${SEC_ANALYST}`]
const orgAdminTenantAdminSecAnalyst = [`${ORG_ADMIN} - ${TENANT_ADMIN} - ${SEC_ANALYST}`]
const contentMngrTenantAdminSecAnalyst = [`${CONTENT_MNGR} - ${TENANT_ADMIN} - ${SEC_ANALYST}`]

// Mapping all TenantAdmin Users with Viewer role
const rootTenantAdminViewer = [`${ROOT} - ${TENANT_ADMIN} - ${VIEWER}`]
const userTenantAdminViewer = [`${USER} - ${TENANT_ADMIN} - ${VIEWER}`]
const orgAdminTenantAdminViewer = [`${ORG_ADMIN} - ${TENANT_ADMIN} - ${VIEWER}`]
const contentMngrTenantAdminViewer = [`${CONTENT_MNGR} - ${TENANT_ADMIN} - ${VIEWER}`]

// Mapping all TenantAdmin Root Users with Security Engineer and Security Analyst role
const rootTenantAdminSec = rootTenantAdminSecEng.concat(rootTenantAdminSecAnalyst)

// Mapping all TenantAdmin General Users with Security Engineer and Security Analyst role
const userTenantAdminSec = userTenantAdminSecEng.concat(userTenantAdminSecAnalyst)

// Mapping all TenantAdmin OrgAdmin Users with Security Engineer and Security Analyst role
const orgadminTenantAdminSec = orgAdminTenantAdminSecEng.concat(orgAdminTenantAdminSecAnalyst)

// Mapping all contentMngr OrgAdmin Users with Security Engineer and Security Analyst role
const contentMngrTenantAdminSec = contentMngrTenantAdminSecEng.concat(
  contentMngrTenantAdminSecAnalyst,
)

// Mapping all TenantAdmin Users with Viewer and No Access role
const rootTenantAdminNonsec = [
  `${ROOT} - ${TENANT_ADMIN} - ${VIEWER}`,
  `${ROOT} - ${TENANT_ADMIN} - ${NO_ACCESS}`,
]
const userTenantAdminNonsec = [
  `${USER} - ${TENANT_ADMIN} - ${VIEWER}`,
  `${USER} - ${TENANT_ADMIN} - ${NO_ACCESS}`,
]
const orgAdminTenantAdminNonsec = [
  `${ORG_ADMIN} - ${TENANT_ADMIN} - ${VIEWER}`,
  `${ORG_ADMIN} - ${TENANT_ADMIN} - ${NO_ACCESS}`,
]
const contentMngrTenantAdminNonsec = [
  `${CONTENT_MNGR} - ${TENANT_ADMIN} - ${VIEWER}`,
  `${CONTENT_MNGR} - ${TENANT_ADMIN} - ${NO_ACCESS}`,
]

// Creating contentMngr OrgAdmin Users
const contentMngrTenantAdminAll = contentMngrTenantAdmin
  .concat(contentMngrTenantAdminSec)
  .concat(contentMngrTenantAdminNonsec)

// Creating TenantAdmin OrgAdmin Users
const orgAdminTenantAdminAll = orgAdminTenantAdmin
  .concat(orgadminTenantAdminSec)
  .concat(orgAdminTenantAdminNonsec)

// Creating TenantAdmin General Users
const userTenantAdminAll = userTenantAdmin.concat(userTenantAdminSec).concat(userTenantAdminNonsec)

// Creating TenantAdmin Root Users
const rootTenantAdminAll = rootTenantAdmin.concat(rootTenantAdminSec).concat(rootTenantAdminNonsec)

const rootAll = rootBasic.concat(rootTenantAdminAll)

const userAll = userBasic.concat(userTenantAdminAll)

const orgadminAll = orgAdminBasic.concat(orgAdminTenantAdminAll)

const contentMngrAll = contentMngrBasic.concat(contentMngrTenantAdminAll)

export const RouteAccess = {
  ROOT: ROOT,
  ORG_ADMIN: ORG_ADMIN,
  USER: USER,
  CONTENT_MNGR: CONTENT_MNGR,
  CONTENT_MNGR_API: CONTENT_MNGR_API,
  SEC_ENG: SEC_ENG,
  SEC_ANALYST: SEC_ANALYST,
  VIEWER: VIEWER,
  NO_ACCESS: NO_ACCESS,

  TENANT_ADMIN: TENANT_ADMIN,
  ADMINISTRATOR: ADMINISTRATOR,
  INIT: INIT,
  CUSTOM: CUSTOM,

  USER_TYPES: [ROOT, ORG_ADMIN, USER, CONTENT_MNGR],

  USER_ROLES: [SEC_ENG, SEC_ANALYST, VIEWER, NO_ACCESS],

  ROOT_INIT_ROLES: rootInitAccess,

  ORG_ADMIN_NO_ACCESS_ROLES: [`${ORG_ADMIN} - ${NO_ACCESS}`],

  CONTENT_MNGR_NO_ACCESS_ROLES: [`${CONTENT_MNGR} - ${NO_ACCESS}`],

  USER_NO_ACCESS_ROLES: [`${USER} - ${NO_ACCESS}`],

  ROOT_NO_ACCESS_ROLES: [`${ROOT} - ${NO_ACCESS}`],

  ROOT_VIEWER_ROLES: [`${ROOT} - ${VIEWER}`],

  USER_VIEWER_ROLES: [`${USER} - ${VIEWER}`],

  ORGADMIN_VIEWER_ROLES: [`${ORG_ADMIN} - ${VIEWER}`],

  CONTENT_MNGR_VIEWER_ROLES: [`${CONTENT_MNGR} - ${VIEWER}`],

  VIEWER_ROLES: rootViewer
    .concat(userViewer)
    .concat(orgAdminViewer)
    .concat(contentMngrViewer)
    .concat(rootTenantAdminViewer)
    .concat(userTenantAdminViewer)
    .concat(orgAdminTenantAdminViewer)
    .concat(contentMngrTenantAdminViewer),

  ROOT_ROLES: rootBasic.concat(rootTenantAdminAll),

  SEC_ANALYSTS_ROLES: rootSecAnalysts
    .concat(orgAdminSecAnalysts)
    .concat(contentMngrSecAnalysts)
    .concat(userSecAnalysts)
    .concat(rootTenantAdminSecAnalyst)
    .concat(userTenantAdminSecAnalyst)
    .concat(orgAdminTenantAdminSecAnalyst)
    .concat(contentMngrTenantAdminSecAnalyst),

  SEC_ENGINEERS_ROLES: rootSecEng
    .concat(orgAdminSecEng)
    .concat(contentMngrSecEng)
    .concat(userSecEng)
    .concat(rootTenantAdminSecEng)
    .concat(userTenantAdminSecEng)
    .concat(orgAdminTenantAdminSecEng)
    .concat(contentMngrTenantAdminSecEng),

  CONTENT_MNGR_TENANT_ADMIN_ROLES: contentMngrTenantAdminAll,

  ORG_ADMIN_TENANT_ADMIN_ROLES: orgAdminTenantAdminAll,

  ROOT_TENANT_ADMIN_ROLES: rootTenantAdminAll,

  USER_TENANT_ADMIN_ROLES: userTenantAdminAll,

  ONLY_TENANT_ADMIN_ROLES: rootTenantAdmin
    .concat(userTenantAdmin)
    .concat(orgAdminTenantAdmin)
    .concat(contentMngrTenantAdmin),

  TENANT_ADMIN_ROLES: rootTenantAdminAll
    .concat(userTenantAdminAll)
    .concat(orgAdminTenantAdminAll)
    .concat(contentMngrTenantAdminAll),

  SEC_TENANT_ADMIN_ROLES: userTenantAdminSec
    .concat(rootTenantAdminSec)
    .concat(orgadminTenantAdminSec)
    .concat(contentMngrTenantAdminSec),

  ORG_ADMIN_ROLES: orgAdminBasic.concat(orgAdminTenantAdminAll),

  CONTENT_MNGR_ROLES: contentMngrBasic.concat(contentMngrTenantAdminAll),

  ALL_ROLES: []
    .concat(rootAll)
    .concat(userAll)
    .concat(orgadminAll)
    .concat(contentMngrAll)
    .concat(rootInitAccess),

  GLOBAL_ACCESS: rootAll
    .concat(userAll)
    .concat(orgadminAll)
    .concat(contentMngrAll)
    .concat(blankAccess)
    .concat(rootInitAccess),
}

// Creating routes - roles map for checking route while cluster/scope change
const routes = [
  {
    title: 'Dashboards',
    key: 'dashboard',
    icon: 'far fa-tachometer-alt',
    roles: []
      .concat(RouteAccess.SEC_ENGINEERS_ROLES)
      .concat(RouteAccess.SEC_ANALYSTS_ROLES)
      .concat(RouteAccess.VIEWER_ROLES),
    urlEnd: '/dashboard',
  },
  {
    title: 'Find',
    key: 'find',
    icon: 'far fa-search',
    roles: []
      .concat(RouteAccess.SEC_ENGINEERS_ROLES)
      .concat(RouteAccess.SEC_ANALYSTS_ROLES)
      .concat(RouteAccess.VIEWER_ROLES),
    urlEnd: '/workbook/new',
  },
  {
    title: 'Cases',
    key: 'cases',
    icon: 'far fa-briefcase',
    roles: []
      .concat(RouteAccess.SEC_ENGINEERS_ROLES)
      .concat(RouteAccess.SEC_ANALYSTS_ROLES)
      .concat(RouteAccess.VIEWER_ROLES),
    urlEnd: '/incident/cases',
  },
  {
    title: 'Signals',
    key: 'signal',
    icon: 'far fa-signal-stream',
    roles: []
      .concat(RouteAccess.SEC_ENGINEERS_ROLES)
      .concat(RouteAccess.SEC_ANALYSTS_ROLES)
      .concat(RouteAccess.VIEWER_ROLES),
    urlEnd: '/incident/signals',
  },
  {
    title: 'Workbooks',
    key: 'workbook',
    icon: 'far fa-book',
    roles: [].concat(RouteAccess.SEC_ENGINEERS_ROLES).concat(RouteAccess.SEC_ANALYSTS_ROLES),
    urlEnd: '/workbook',
  },
  {
    title: 'Reports',
    key: 'reports',
    icon: 'far fa-file-chart-line',
    roles: [].concat(RouteAccess.SEC_ENGINEERS_ROLES).concat(RouteAccess.SEC_ANALYSTS_ROLES),
    urlEnd: '/reports',
  },
  {
    title: 'MITRE ATT&CK',
    key: 'mitre_attack',
    icon: 'far fa-link',
    roles: [].concat(RouteAccess.SEC_ENGINEERS_ROLES).concat(RouteAccess.SEC_ANALYSTS_ROLES),
    urlEnd: '/mitre_attack',
  },
  {
    title: 'Streams',
    key: 'streams',
    icon: 'far fa-waveform-path',
    roles: [].concat(RouteAccess.SEC_ENGINEERS_ROLES).concat(RouteAccess.VIEWER_ROLES),
    urlEnd: '/stream/list',
  },
  {
    title: 'EBA',
    key: 'eba',
    icon: 'far fa-user-chart',
    roles: [].concat(RouteAccess.SEC_ENGINEERS_ROLES),
    urlEnd: '/eba',
  },
  {
    category: true,
    key: 'system',
    title: '',
    roles: [].concat(RouteAccess.SEC_ENGINEERS_ROLES),
  },
  {
    title: 'Utilization',
    key: 'utilization',
    // roles: RouteAccess.SEC_ENGINEERS_ROLES.concat(RouteAccess.SEC_TENANT_ADMIN_ROLES),
    roles: RouteAccess.TENANT_ADMIN_ROLES.concat(RouteAccess.ROOT_ROLES)
      .concat(RouteAccess.ROOT_INIT_ROLES)
      .concat(RouteAccess.ROOT_VIEWER_ROLES),
    urlEnd: '/system/utilization',
  },
  {
    title: 'Collection Status',
    key: 'collection_status',
    roles: RouteAccess.SEC_ENGINEERS_ROLES.concat(RouteAccess.TENANT_ADMIN_ROLES)
      .concat(RouteAccess.ROOT_ROLES)
      .concat(RouteAccess.ROOT_INIT_ROLES)
      .concat(RouteAccess.ROOT_VIEWER_ROLES)
      .concat(RouteAccess.VIEWER_ROLES),
    urlEnd: '/system/collection_status',
  },
  {
    title: 'Enrichment',
    key: 'enrichment',
    roles: RouteAccess.TENANT_ADMIN_ROLES.concat(RouteAccess.SEC_ENGINEERS_ROLES),
    urlEnd: '/system/enrichment',
  },
  {
    title: 'Eventstores',
    key: 'events',
    roles: RouteAccess.TENANT_ADMIN_ROLES.concat(RouteAccess.SEC_ENGINEERS_ROLES),
    urlEnd: '/system/eventstores',
  },
  {
    title: 'Extraction',
    key: 'extraction',
    roles: RouteAccess.TENANT_ADMIN_ROLES.concat(RouteAccess.SEC_ENGINEERS_ROLES),
    urlEnd: '/system/extraction',
  },
  {
    title: 'Geo Enrichment',
    key: 'geodb',
    roles: RouteAccess.TENANT_ADMIN_ROLES.concat(RouteAccess.SEC_ENGINEERS_ROLES),
    urlEnd: '/system/geodb',
  },
  {
    title: 'Automation',
    key: 'automation',
    roles: RouteAccess.TENANT_ADMIN_ROLES.concat(RouteAccess.SEC_ENGINEERS_ROLES),
    urlEnd: '/system/integrations',
  },
  {
    title: 'Signal Suppression Rules',
    key: 'signalsuppression',
    roles: RouteAccess.TENANT_ADMIN_ROLES.concat(RouteAccess.SEC_ENGINEERS_ROLES),
    urlEnd: '/system/signalsuppression',
  },
  {
    title: 'Slow Queries',
    key: 'slowQuery',
    roles: RouteAccess.TENANT_ADMIN_ROLES.concat(RouteAccess.SEC_ENGINEERS_ROLES),
    urlEnd: '/system/slow-queries',
  },
  {
    title: 'Manage Tokens',
    key: 'token',
    roles: RouteAccess.TENANT_ADMIN_ROLES.concat(RouteAccess.SEC_ENGINEERS_ROLES),
    urlEnd: '/system/token',
  },
  {
    title: 'Machine Learning',
    key: 'models',
    roles: RouteAccess.TENANT_ADMIN_ROLES.concat(RouteAccess.SEC_ENGINEERS_ROLES),
    urlEnd: '/system/models',
  },
  {
    title: 'Administration',
    key: 'secadmin',
    roles: RouteAccess.TENANT_ADMIN_ROLES,
    urlEnd: '/system/components',
  },
  {
    title: 'Data Sources',
    key: 'connectors',
    roles: RouteAccess.TENANT_ADMIN_ROLES,
    urlEnd: '/system/connectors',
  },
  {
    title: 'Tenants',
    key: 'tenants',
    roles: RouteAccess.TENANT_ADMIN_ROLES.concat(RouteAccess.ROOT_ROLES)
      .concat(RouteAccess.ROOT_INIT_ROLES)
      .concat(RouteAccess.ROOT_VIEWER_ROLES),
    urlEnd: '/admin/tenants/list',
  },
  {
    title: 'Organizations',
    key: 'organization',
    roles: RouteAccess.ORG_ADMIN_ROLES.concat(RouteAccess.ROOT_ROLES)
      .concat(RouteAccess.ROOT_INIT_ROLES)
      .concat(RouteAccess.ROOT_VIEWER_ROLES),
    urlEnd: '/admin/organizations/list',
  },
  // {
  //   title: 'Users',
  //   key: 'user',
  //   roles: RouteAccess.ROOT_ROLES.concat(RouteAccess.ROOT_INIT_ROLES),
  //   urlEnd: '/admin/users/list',
  // },
  {
    category: true,
    key: 'admin',
    title: '',
    roles: RouteAccess.ROOT_ROLES.concat(RouteAccess.ROOT_INIT_ROLES).concat(
      RouteAccess.ROOT_VIEWER_ROLES,
    ),
  },
  {
    title: 'Configure SMTP',
    key: 'smtp',
    roles: RouteAccess.ROOT_ROLES.concat(RouteAccess.ROOT_VIEWER_ROLES),
    urlEnd: '/admin/smtp',
  },
  {
    title: 'Mission Control',
    key: 'clusters',
    roles: RouteAccess.ROOT_ROLES.concat(RouteAccess.ROOT_VIEWER_ROLES),
    urlEnd: '/admin/clusters',
  },
  {
    title: 'Manage Components',
    key: 'components',
    roles: RouteAccess.ROOT_ROLES.concat(RouteAccess.ROOT_VIEWER_ROLES).concat(
      RouteAccess.TENANT_ADMIN_ROLES,
    ),
    urlEnd: '/admin/components',
  },
  {
    title: 'Switchboard',
    key: 'switch',
    roles: RouteAccess.ROOT_ROLES.concat(RouteAccess.ROOT_VIEWER_ROLES),
    urlEnd: '/admin/switchboard',
  },
  {
    title: 'Home',
    key: 'home',
    roles: RouteAccess.SEC_ANALYSTS_ROLES.concat(RouteAccess.SEC_ENGINEERS_ROLES),
    urlEnd: '/home',
  },
]
RouteAccess['routes'] = routes

export default RouteAccess
